
// SVG Icon: story
export default { id: "terriajs-story" };
export const id = "terriajs-story";
export const name = "story";
